'use client';

import React from 'react';
import { FileText, Plus, ArrowLeft } from 'lucide-react';
import type { InvoiceView } from '../page';

interface InvoiceHeaderProps {
  view: InvoiceView;
  onBack: () => void;
  onCreateNew: () => void;
}

export default function InvoiceHeader({ view, onBack, onCreateNew }: InvoiceHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {view !== 'list' && (
          <button
            onClick={onBack}
            className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={18} />
          </button>
        )}
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center">
            <FileText size={18} className="text-primary" />
          </div>
          <div>
            <h1 className="text-xl font-700 text-foreground leading-tight">
              {view === 'list' ? 'Invoicing' : 'New Invoice'}
            </h1>
            <p className="text-xs text-muted-foreground">
              {view === 'list' ? 'Manage and generate client invoices' : 'Build invoice from tracked hours'}
            </p>
          </div>
        </div>
      </div>
      {view === 'list' && (
        <button
          onClick={onCreateNew}
          className="btn-primary flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-600"
        >
          <Plus size={16} />
          New Invoice
        </button>
      )}
    </div>
  );
}
